var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"comp-yu-shang-top-up"},[_c('TopupComp',{attrs:{"isCanPay":true}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ps"},[_c('h3',[_vm._v("说明:")]),_c('p',[_vm._v("1、充值一元可兑换10个C币；")]),_c('p',[_vm._v("2、已购买的C币仅限在本平台消费；")]),_c('p',[_vm._v("3、如需退款，请联系本次活动主办方工作人员；")])])
}]

export { render, staticRenderFns }